

































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { qcList, qcOperation, qcOperationAll } from '@/api/task/crowd';
import { detail as taskDetail,useStatisticList } from '@/api/task/common';
import { detail as judgeDetail } from '@/api/task/judge';
import { qcCheat } from '@/api/task/crowd';
import {DOMAIN, HTTPDOMAIN,mobileProject} from '@/global/constants';
import inspectExpand from '@/components/inspectExpand.vue';

@Component({
  components: {
    inspectExpand,
  },
})
export default class InpectUser extends Vue {
  private dataList: object[] = [];
  private task: object = {};
  private showId: string = '0';
  private total: number | string = 0;

  // 搜索 入参
  private searchParams: object = {
    mid: '',
    check_uid: '',
    team_group_id: '',
    count_status:''
  };

  private columnsSchema: object[] = [
    // {
    //   type: 'expand',
    //   width: 50,
    //   render: (h, params) => {
    //     return h(inspectExpand, {
    //       props: {
    //         row: params.row,
    //       },
    //     });
    //   },
    // },
    {
      title: '标注小队ID',
      key: 'team_group_id',
      align: 'center',
    },
    {
      title: '审核人ID',
      key: 'uid',
      align: 'center',
    },
    {
      title: '审核人',
      key: 'nick_name',
      align: 'center',
    },
    {
      title: '审核数量',
      key: 'join_count',
      align: 'center',
    },
    {
      title: '质检数量',
      key: 'complete_count',
      align: 'center',
    },
    {
      title: '质检进度',
      key: 'progress',
      align: 'center',
    },
    {
      title: '质检成功率',
      key: 'success_rate',
      align: 'center',
    },
    {
      title: '操作',
      key: 'answer',
      align: 'center',
      slot: 'operate',
    },
  ];
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name == 'inspectPackage') {
      this.handlereset()
      this.getTask(); // 重新加载数据
    }
  }
  private created() {
    this.getList({});
    this.getTask();
  }
  private async getList(params) {
    // 质检列表 入参

    const new_params = Object.assign(
      { mid: this.$route.params.id, pkg_id: this.$route.params.pkg_id },
      params
    );

    const data = (await useStatisticList(new_params)) as any;
    this.$nextTick(() => {
      this.dataList = data ? data : [];
      let list=[];
      if(this.searchParams['count_status'] == '1'){
        data.forEach((item)=>{
          if(item.complete_count != 0 || item.join_count !=0){
            list.push(item)
          }
        })
        this.dataList = list;
      }
    });

    const count_params = Object.assign(
      { page: 1,pageSize:1},
      new_params
    );
    const countData = (await qcList(count_params)) as any;
    this.$nextTick(() => {
      this.total = countData ? countData.total : 0;
    });

  }
  private async getTask() {
    this.task = this.$store.state.task;
    if (!(this.task && (this.task as any).id)) {
      const page = this.$route.params.page;
      const params = { id: this.$route.params.id };
      let resp: any;
      if (page == 'judge') {
        resp = await judgeDetail(params);
      } else {
        resp = await taskDetail(params);
      }
      this.$nextTick(() => {
        this.task = resp.result;
        this.$store.commit('setTask', resp.result);
      });
    }
  }
  // 搜索
  private handleSearch() {
    let options = {};
    const params = this.searchParams;

    for (let key in params) {
      if (params[key] !== '') {
        options[key] = params[key];
      }
    }
    this.getList(options);
  }
  // 重置
  private handlereset() {
    this.searchParams = {
      mid: '',
      check_uid: '',
      team_group_id: '',
      count_status:'',
    };
    this.getList({});
  }
  //查看
  private handlecheck(row) {
    const task: any = this.task;
    let params: any = Object.assign({});
    params.id = task.id;
    params.puid=row.uid;
    if(this.$route.params.page){
      params.page=this.$route.params.page
    }else{
      params.page='crowd'
    }
    if(this.$route.params.pkg_id){
      params.pkg_id =this.$route.params.pkg_id
    }
    this.$router.push({
        name: 'inspectDetail',
        params: params,
        query: { pkg_id: this.$route.params.pkg_id}
      });

  }
  private formatDuring(mss) {
    if (mss < 60) {
      return `0分${mss}秒`;
    }
    let s = parseInt((mss % 60).toString()); // 秒
    let m = parseInt((mss / 60).toString()); // 分
    if (m > 60) {
      var h = parseInt((m / 60).toString()); // 小时
      m = parseInt((m % 60).toString());
    }
    if (h) {
      if (m) {
        return `${h}时${m}分${s}秒`;
      } else {
        return `${h}时0分${s}秒`;
      }
    }
    if (m) {
      return `${m}分${s}秒`;
    } else {
      return `0分${s}秒`;
    }
    return;
  }
}
